<div class="exception-body error">
  <div class="exception-content">
    <div class="moon">
      <img src="assets/img/portal/asset-moon.svg" alt="error" />
    </div>
    <div class="exception-panel">
      <div class="exception-panel-content">
        <h1>Oh no! Something went wrong!</h1>
        <div class="seperator"></div>
        <p>{{ resolvedMessage }}</p>

        <div class="buttons">
          <button pButton *ngIf="!isKeyCloakError" type="button" (click)="logout()" label="Log Out"></button>
          <button pButton type="button" (click)="openSupport()" label="Contact support"></button>
        </div>
      </div>
    </div>
    <div class="desert"></div>
  </div>
</div>


